import update from "immutability-helper";

import { PREPSESSION_CLEAR, PREPSESSION_LOADED } from "../actions/types";

// prepare reducer
const prepareReducer = (state: { prepSession?: any } = {}, action) => {
  switch (action.type) {
    case PREPSESSION_LOADED: {
      return update(state, { prepSession: { $set: action.payload } });
    }
    case PREPSESSION_CLEAR: {
      return update(state, { prepSession: { $set: 0 } });
    }
    default:
      return state;
  }
};

export default prepareReducer;
